// 匹配标准 IP 地址的正则表达式，最后一段数字为1到254
let ipRegex =
  /^(?!255)(?!0)\b(25[0-4]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-4]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-4]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[1-4]|2[0-4][0-9]|[01]?[0-9][0-9]?)\b$/;

// 特殊 IP 地址范围，需要排除的连续段特殊 IP 地址
export const specialRanges = [
  { start: "224.0.0.0", end: "224.0.0.255" },
  { start: "224.0.1.0", end: "231.255.255.255" },
  { start: "232.0.0.0", end: "232.255.255.255" },
  { start: "233.0.0.0", end: "238.255.255.255" },
  { start: "239.0.0.0", end: "239.255.255.255" },
];

// 特定的 IP 地址需要排除
export const excludeIPs = ["255.255.255.255", "127.0.0.1"];

// 非0.0.0.0的IP地址正则
export const notAllZoneIpReg =
  /^(?!0\.0\.0\.0)(\b(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/; // 排除0.0.0.0的ip规则

export function isSpecialIP(ip) {
  for (let range of specialRanges) {
    let startIpParts = range.start.split(".").map(Number);
    let endIpParts = range.end.split(".").map(Number);
    let ipParts = ip.split(".").map(Number);

    let isInRange = true;
    for (let i = 0; i < 4; i++) {
      if (ipParts[i] < startIpParts[i] || ipParts[i] > endIpParts[i]) {
        isInRange = false;
        break;
      }
    }

    if (isInRange) {
      return true;
    }
  }

  if (excludeIPs.includes(ip)) {
    return true;
  }

  return false;
}

export function validateIP(ip) {
  if (ipRegex.test(ip) && !isSpecialIP(ip)) {
    return true; // IP 地址有效且不在特定范围内的连续段特殊 IP 地址中
  } else {
    return false; // IP 地址无效或在特定范围内的连续段特殊 IP 地址中
  }
}
/** 获取自动生成的ip地址，特殊的排除掉
 *  @param startIP 起始ip
 *  @param numDevices 数量
 *  @return deviceIPs 返回设备ip
 */
export function generateDeviceIPs(startIP, numDevices) {
  let deviceIPs = [];
  let ipParts = startIP.split(".").map(Number);

  for (let i = 1; i <= numDevices; i++) {
    let lastOctet = ((ipParts[3] + i) % 254) + 1; // 保证最后一段数字在1到254之间
    let ip = `${ipParts[0]}.${ipParts[1]}.${ipParts[2]}.${lastOctet}`;

    if (!isSpecialIP(ip)) {
      deviceIPs.push(ip);
    }
  }

  return deviceIPs;
}
/**
 * 将 IP 地址转换为二进制形式
 * @param ip
 * @return binaryIP 相&结果
 */

export function ipToBinary(ip) {
  // 将 IP 地址拆分为四个部分
  let ipParts = ip.split(".");

  // 将每个部分转换为二进制形式并补齐 8 位
  let binaryParts = ipParts.map(function (part) {
    let binary = parseInt(part).toString(2);
    return binary.padStart(8, "0");
  });

  // 将四个二进制部分组合起来
  let binaryIP = binaryParts.join(".");

  return binaryIP;
}

/**
 * 检查IP地址与子网掩码对应位置的按位与操作是否返回全为1或全为0
 * @param ipAddress
 * @param subnetMask
 * @return result  true:是全1或全0；false：非
 */
export function checkIPAndSubnet(ipAddress, subnetMask) {
  const ALLONE = "11111111111111111111111111111111";
  const ALLZORE = "00000000000000000000000000000000";

  let ipParts = ipAddress.split(".").map((part) => parseInt(part));
  let maskParts = subnetMask.split(".").map((part) => parseInt(part));

  let result = "";
  for (let i = 0; i < 4; i++) {
    let ipBinary = ipParts[i].toString(2).padStart(8, "0");
    let maskBinary = maskParts[i].toString(2).padStart(8, "0");

    let andResult = "";
    for (let j = 0; j < 8; j++) {
      if (ipBinary.charAt(j) === "1" && maskBinary.charAt(j) === "1") {
        andResult += "1";
      } else {
        andResult += "0";
      }
    }

    result += andResult;
  }

  return result === ALLONE || result === ALLZORE;
}

/**
 * 生成后续 IP 地址
 * @param ip ip地址
 * @param subnetMask 子网掩码
 * @return bool
 */
export function generateNextIP(ip) {
  let parts = ip.split(".");
  let lastPart = parseInt(parts[3]) + 1;
  if (lastPart > 255) {
    lastPart = 0;
    parts[2] = parseInt(parts[2]) + 1;
    if (parts[2] > 255) {
      parts[2] = 0;
      parts[1] = parseInt(parts[1]) + 1;
      if (parts[1] > 255) {
        parts[1] = 0;
        parts[0] = parseInt(parts[0]) + 1;
      }
    }
  }
  return parts.slice(0, 3).join(".") + "." + lastPart;
}

/**
 * 批量添加设备 IP 地址
 * @param startIP 起始ip地址
 * @param subnetMask 子网掩码
 * @param count 数量
 * @return bool
 */
export function addDeviceIP(startIP, subnetMask) {
  let currentIP = startIP;
  debugger;
  let result = checkIPAndSubnet(currentIP, subnetMask);

  if (!result) {
    currentIP = generateNextIP(currentIP);
  } else {
    // 新增满足条件的下一个ip，
    while (result) {
      currentIP = generateNextIP(currentIP);
      result = checkIPAndSubnet(currentIP, subnetMask);
    }
  }

  return currentIP;
}
